import Component from '../../../scripts/utilities/component';

class TicketsInfo extends Component {
    componentDidMount() {
        this.panel = this.root.nextElementSibling;
        if (
            !this.panel.dataset.ref ||
            (this.panel.dataset.ref && !this.panel.dataset.ref === 'ticketInfoPanel')
        ) {
            console.error('The ticketInfoPanel must the next direct sibling of the close button');
        }
        this.close = this.panel.querySelector('[data-ref="ticketInfoClose"]');

        this.attachListeners();
    }

    attachListeners() {
        this.root.addEventListener('click', this.toggleHiddenClass.bind(this), true);
        this.close.addEventListener('click', this.toggleHiddenClass.bind(this), true);
    }

    toggleHiddenClass(e) {
        e.preventDefault();
        this.panel.classList.toggle('tickets__info--hidden');
    }
}

export default TicketsInfo;



// WEBPACK FOOTER //
// ./components/eng-ms-tickets/scripts/tickets-info.js